import Lenis from 'lenis'
import 'lenis/dist/lenis.css'
import { gsap } from "gsap";

// 参考
// https://stackblitz.com/edit/withastro-astro-14jxyu1u?file=src%2Fpages%2Findex.astro
class ScrollSmoother {
  constructor() {    
    this.init();
  }
  
  init() {
    /**
     * イージング関数
     * @see https://easings.net/ja
     * @param {number} x アニメーションの進行度（正規化された0から1までの値）
     * @return {number} イージングを適用した後の進行度（正規化された0から1までの値）
     */
    const easeOutQuart = (x) => {
      return 1 - Math.pow(1 - x, 4);
    };

    // 初期化 - autoRafをfalseにして手動制御
    const lenis = new Lenis({
      autoRaf: false, // 手動制御に変更
      lerp: 0.15, // 慣性を軽く調整
      duration: 0.8, // 時間を短縮
      easing: easeOutQuart, // イージング関数
    });
    
    // LenisのrafメソッドをGSAP tickerに統合してパフォーマンス最適化
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000); // tickerのタイムスタンプの単位は秒なので、ミリ秒に変換
    });

    // レンダリング時にラグが発生した際のアニメーション調整機能を無効化
    gsap.ticker.lagSmoothing(0);
    
    // グローバルにlenisインスタンスを保存（他のクラスからアクセス可能にする）
    window.lenisInstance = lenis;
  }

  customSetup() {
    // この関数は使用されていないため削除
    // LenisはGSAP tickerで制御されています
  }
}

export default ScrollSmoother
